import React from 'react';
import { motion } from 'framer-motion';

const GlobalBackground: React.FC = () => {
  return (
    <>
      {/* Dark base */}
      <div
        style={{
          position: 'fixed',
          inset: 0,
          background: '#09080a',
          zIndex: 0,
        }}
      />

      {/* Animated blobs */}
      {/* Orange — top left */}
      <motion.div
        style={{
          position: 'fixed',
          top: '-10%',
          left: '-10%',
          width: '55vw',
          height: '55vw',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(249,115,22,0.18) 0%, transparent 70%)',
          filter: 'blur(80px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
        animate={{ x: [0, 30, 0], y: [0, -20, 0] }}
        transition={{ duration: 18, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Violet — bottom right */}
      <motion.div
        style={{
          position: 'fixed',
          bottom: '-15%',
          right: '-10%',
          width: '50vw',
          height: '50vw',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 70%)',
          filter: 'blur(80px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
        animate={{ x: [0, -25, 0], y: [0, 25, 0] }}
        transition={{ duration: 22, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Amber — top right */}
      <motion.div
        style={{
          position: 'fixed',
          top: '20%',
          right: '-5%',
          width: '35vw',
          height: '35vw',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(245,158,11,0.08) 0%, transparent 70%)',
          filter: 'blur(60px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
        animate={{ x: [0, -15, 0], y: [0, 30, 0] }}
        transition={{ duration: 25, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Plum — bottom left */}
      <motion.div
        style={{
          position: 'fixed',
          bottom: '10%',
          left: '-5%',
          width: '40vw',
          height: '40vw',
          borderRadius: '50%',
          background:
            'radial-gradient(circle, rgba(168,85,247,0.07) 0%, transparent 70%)',
          filter: 'blur(70px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
        animate={{ x: [0, 20, 0], y: [0, -15, 0] }}
        transition={{ duration: 20, repeat: Infinity, ease: 'easeInOut' }}
      />

      {/* Grain overlay */}
      <div className="grain-overlay" />
    </>
  );
};

export default GlobalBackground;
